import { DateTime } from 'luxon';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { stopCountdown } from 'store/cartSlice';
import {
  selectCartCountdown,
  selectEventFromCart,
} from 'store/cartSlice/selectors';
import { getTicketsPageLink } from 'utils/events';

const CartCountdownTimer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { onGoing, endTime } = useSelector(selectCartCountdown);
  const {
    id: eventId,
    name: eventName,
    type,
  } = useSelector(selectEventFromCart);
  const defaultValue = Math.round(
    DateTime.fromISO(endTime).diffNow('seconds').seconds,
  );
  const [secondsRemaining, setSecondsRemaining] = useState(
    defaultValue >= 0 ? defaultValue : 0,
  );

  window.onfocus = () => {
    if (defaultValue > 0) {
      setSecondsRemaining(defaultValue);
    } else {
      setSecondsRemaining(0);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsRemaining(secondsRemaining => secondsRemaining - 1);
    }, 1000);

    if (onGoing === false) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [onGoing]);

  useEffect(() => {
    if (secondsRemaining === 0) {
      dispatch(stopCountdown());
    }
  }, [dispatch, secondsRemaining]);

  const secondsToDisplay = secondsRemaining % 60;
  const minutesRemaining = (secondsRemaining - secondsToDisplay) / 60;
  const minutesToDisplay = minutesRemaining % 60;

  return (
    <div className="countdown-container mx-auto sm:mx-0 flex gap-1 items-center justify-center flex-wrap">
      <p className="p2-regular text-neutral-800">
        {onGoing ? (
          t('registrationPage.expirationMessage')
        ) : (
          <>
            {t('registrationPage.remainingTimeHasExpired')}{' '}
            <Link to={getTicketsPageLink(eventName, eventId, type)}>
              <span className="text-blue-1000 underline">
                {t('registrationPage.backToTicketsPage')}
              </span>
            </Link>
          </>
        )}
      </p>
      <p className="p2-semibold mx-auto md:mx-0 w-fit min-w-[48px] rounded-sm text-center text-red-1000 bg-red-20">
        {onGoing
          ? `${minutesToDisplay.toString().padStart(2, '0')}:${secondsToDisplay
              .toString()
              .padStart(2, '0')}`
          : '00:00'}
      </p>
    </div>
  );
};

export default CartCountdownTimer;
